import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-gray-50" data-id="element-270">
      <div className="max-w-3xl mx-auto" data-id="element-271">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-272">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-10" data-id="element-273">
            ✨ MEGAPACK MI ESPACIO INTERIOR — 6 Tomos + 6 Bonos
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-dashed border-red-200 mb-12" data-id="element-274">
            <ul className="text-left space-y-6 text-lg text-gray-700 max-w-2xl mx-auto font-medium" data-id="element-275">
              <li className="flex items-start gap-4" data-id="element-276">
                <span className="text-3xl" data-id="element-277">📘</span>
                <p data-id="element-278">
                  <span className="font-bold text-gray-900" data-id="element-279">
                    Tomo 1 — El Espejo:
                  </span>{' '}
                  Reconocerse y nombrarse emocionalmente. El adolescente aprende
                  a identificar qué siente, por qué lo siente y cómo ponerle
                  nombre.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-280">
                <span className="text-3xl" data-id="element-281">📙</span>
                <p data-id="element-282">
                  <span className="font-bold text-gray-900" data-id="element-283">
                    Tomo 2 — El Volcán:
                  </span>{' '}
                  Identificar el enojo antes de explotar. Herramientas para
                  reconocer las señales del enojo, frenar la reacción impulsiva
                  y canalizar la energía.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-284">
                <span className="text-3xl" data-id="element-285">📗</span>
                <p data-id="element-286">
                  <span className="font-bold text-gray-900" data-id="element-287">
                    Tomo 3 — El Escudo:
                  </span>{' '}
                  Recursos internos de protección emocional. Desarrolla la
                  capacidad de protegerse frente a presión social, bullying y
                  redes sociales.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-288">
                <span className="text-3xl" data-id="element-289">📕</span>
                <p data-id="element-290">
                  <span className="font-bold text-gray-900" data-id="element-291">
                    Tomo 4 — El Timón:
                  </span>{' '}
                  Tomar decisiones con calma y propósito. Aprende a pausar,
                  evaluar opciones y elegir con claridad.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-292">
                <span className="text-3xl" data-id="element-293">📓</span>
                <p data-id="element-294">
                  <span className="font-bold text-gray-900" data-id="element-295">
                    Tomo 5 — El Puente:
                  </span>{' '}
                  Reconstruir vínculos y comunicarse con adultos. Herramientas
                  para que el adolescente aprenda a expresarse y el adulto
                  aprenda a escuchar diferente.
                </p>
              </li>
              <li className="flex items-start gap-4 bg-yellow-50 p-4 rounded-xl border border-yellow-200" data-id="element-296">
                <span className="text-3xl" data-id="element-297">📔</span>
                <p data-id="element-298">
                  <span className="font-bold text-gray-900" data-id="element-299">
                    Tomo 6 — El Mapa:
                  </span>{' '}
                  Plan de bienestar emocional personal. El adolescente crea su
                  propio plan de bienestar: rutinas, recursos, personas de
                  confianza y estrategias personalizadas.
                </p>
              </li>
            </ul>
          </div>

          <div className="max-w-md mx-auto" data-id="element-300">
            <CTAButton text="👉 QUIERO MI MEGAPACK AHORA" data-id="element-301" />
          </div>
        </div>
      </div>
    </section>;
}